import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog__header" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDialog',
  props: {
  title: {
    type: String,
    required: true,
  },
  setDay: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;




const tryClose = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      onClick: tryClose,
      class: "backdrop"
    }),
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withCtx(() => [
        _createElementVNode("dialog", {
          class: _normalizeClass(["dialog", {
          'dialog--days': __props.setDay,
        }]),
          open: ""
        }, [
          _createElementVNode("header", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("h2", null, _toDisplayString(props.title), 1)
            ]),
            _createElementVNode("menu", { class: "dialog__menu" }, [
              _createElementVNode("i", {
                onClick: tryClose,
                class: "fa-sharp fa-solid fa-circle-xmark dialog__close"
              })
            ])
          ]),
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]),
      _: 3
    })
  ]))
}
}

})